<template>
    <section class="bereikt title">
        <ogt-video ref="video" src="/static/video/bereikt.mp4" poster="/static/video/bereikt-poster.jpg"></ogt-video>
        <h1>Dit bereikten we in 2021</h1>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_title.scss
</style>

<script>
    import { gsap } from '@/vendor';

    import OgtVideo from '@/app/components/OgtVideo';
    import InfoStudenten from '@/app/pages/bereikt/InfoStudenten.vue';
    import InfoMedewerker from '@/app/pages/bereikt/InfoMedewerker.vue';

    import Intro from '@/app/pages/bereikt/Intro.vue';
    import Interview from '@/app/pages/bereikt/Interview.vue';

    import InterviewFredCarl from '@/app/pages/sub/InterviewFredCarl';

    export default {
        name: 'Bereikt',
        meta: {
            title: '3. Dit bereikten we in 2021',
            color: '#a5147e',
            slides: [ Intro, Interview, InfoMedewerker, InfoStudenten ]
        },

        components: {
            'ogt-video': OgtVideo
        },

        props: {
            meta: {
                default: () => {},
                type: Object
            }
        },

        mounted()
        {
            this.tl = gsap.timeline({ paused: true });
            this.tl.fromTo( 'section.bereikt.title h1', { y: 20, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.5 });
        },

        methods: {
            focus()
            {
                this.tl.play();
                this.$refs.video.play();
            },
            blur()
            {
                this.$refs.video.pause();
            },

            sub( name )
            {
                switch( name )
                {
                    case 'FredEnCarl':
                        this.$emit( 'openOverlay', InterviewFredCarl, this.meta.index + 2 );
                        break;
                }
            }
        }
    };
</script>
